import { ArrowUpRight } from "lucide-react";

type Props = {
    title: string;
    href: string;
}

export default function ExternalLink({ title, href }: Props) {
    return (
        <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="group/link relative flex items-center justify-between gap-2 py-1 text-foreground"
        >
            <span className="text-sm font-medium">{title}</span>
            <ArrowUpRight className="w-4 h-4" />
            <span
                aria-hidden
                className="pointer-events-none absolute bottom-0 left-0 h-px w-0 bg-foreground transition-[width] duration-300 ease-out group-hover/link:w-full"
            />
        </a>
    )
}